interface RelatedProduct {
  id: string;
  productId: number;
  name: string;
  skuId: string;
}

export interface ServiceData {
  id: string;
  serviceId: number;
  name: string;
  serviceBankName: string;
  quantity: number;
  packaging: number;
  packagingCount: number;
  uniqueProductsCount: number;
  price: {
    subTotal: number;
    unit: number;
  };
  relatedProduct: RelatedProduct | null;
}

export class Service {
  id;
  serviceId;
  name;
  serviceBankName;
  quantity;
  packaging;
  packagingCount;
  uniqueProductsCount;
  price;
  relatedProduct;
  isStandalone;

  constructor(data: ServiceData) {
    this.id = data.id;
    this.serviceId = data.serviceId;
    this.name = data.name;
    this.serviceBankName = data.serviceBankName;
    this.quantity = data.quantity;
    this.packaging = data.packaging;
    this.packagingCount = data.packagingCount;
    this.uniqueProductsCount = data.uniqueProductsCount;
    this.price = data.price;
    this.relatedProduct = data.relatedProduct;
    this.isStandalone = this.#buildIsStandalone();
  }

  #buildIsStandalone() {
    return !this.relatedProduct;
  }
}
